import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import addon_45modules_45global from "/app/apps/frontend/middleware/addon-modules.global.ts";
import color_45mode_45global from "/app/apps/frontend/middleware/color-mode.global.ts";
import setup_45wizard_45global from "/app/apps/frontend/middleware/setup-wizard.global.ts";
import shop_45domain_45global from "/app/apps/frontend/middleware/shop-domain.global.ts";
import shop_45global from "/app/apps/frontend/middleware/shop.global.ts";
import storefront_45lock_45global from "/app/apps/frontend/middleware/storefront-lock.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  addon_45modules_45global,
  color_45mode_45global,
  setup_45wizard_45global,
  shop_45domain_45global,
  shop_45global,
  storefront_45lock_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  admin: () => import("/app/apps/frontend/middleware/admin.ts"),
  auth: () => import("/app/apps/frontend/middleware/auth.ts"),
  "catalog-pro": () => import("/app/apps/frontend/middleware/catalog-pro.ts"),
  generators: () => import("/app/apps/frontend/middleware/generators.ts"),
  offers: () => import("/app/apps/frontend/middleware/offers.ts"),
  platform: () => import("/app/apps/frontend/middleware/platform.ts"),
  refurbished: () => import("/app/apps/frontend/middleware/refurbished.ts"),
  returns: () => import("/app/apps/frontend/middleware/returns.ts"),
  sell: () => import("/app/apps/frontend/middleware/sell.ts")
}